import { ZOOM_BAR_HEIGHT } from 'src/constants';

import { FitContentToWrapperProps } from '../ScaleContainer.interface';

export const fitContentToWrapper = ({
  wrapperRef,
  contentRef,
  callback,
  options,
}: FitContentToWrapperProps) => {
  if (wrapperRef?.current && contentRef?.current) {
    const wrapperWidth = wrapperRef.current.clientWidth;
    const wrapperHeight =
      wrapperRef.current.clientHeight -
      (options?.isScaleControlsHidden ? 0 : ZOOM_BAR_HEIGHT);

    const contentWidth = contentRef.current.scrollWidth;
    const contentHeight = contentRef.current.scrollHeight;

    const widthScale = wrapperWidth / contentWidth;
    const heightScale = wrapperHeight / contentHeight;

    const scale = widthScale < heightScale ? widthScale : heightScale;
    callback && callback(scale);

    return scale;
  }
};
